export function arrayOfObjectsToSingleObject(arr, key, value) {
  var reducer = (obj, item) => ({ ...obj, [item[key]]: item[value] });
  return arr.reduce(reducer, {});
}

export function isEmpty(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

export function getObjectWithoutEmptyValues(object) {
  return Object.entries(object).reduce(
    (result, [key, value]) => (value ? { ...result, [key]: value } : result),
    {}
  );
}

// Converts array of strings to array of object {id: index, key: stringValue}
export function arrayOfStringsToArrayOfIdKeyObjects(arr) {
  var newArr = [];
  arr.forEach((element, index) => {
    newArr.push({ id: index.toString(), key: element });
  });
  return newArr;
}

// Converts Date object to pretty timestamp
export function formatTime(timestamp) {
  return new Intl.DateTimeFormat(navigator.language, {
    dateStyle: "medium",
    timeStyle: "long",
  }).format(timestamp);
}

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}
